<template>
  <base-nav
    class="navbar-top navbar-dark"
    id="navbar-main"
    :show-toggle-button="false"
    expand
  >
    <form
      class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"
    >
      <div class="form-group mb-0"></div>
    </form>
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="CLP Logo" src="/img/brand/barter-logo.png" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold"
                >{{ accountName }} - {{ username }}</span
              >
              <br />
              <span class="mb-0 text-sm font-weight-bold">{{ siteName }}</span>
            </div>
          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">User</h6>
            </div>
            <router-link to="/admin/settings" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>Settings</span>
            </router-link>

            <!-- <a
              href="javascript:void(0)"
              class="dropdown-item"
              @click="switchSiteModal = true"
            >
              <i class="fa fa-sitemap"></i>
              <span>Switch Site</span>
            </a> -->

            <router-link to="/admin/data-privacy-policy" class="dropdown-item">
              <i class="fa fa-upload"></i>
              <span>Data Privacy Policy</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item" @click="logout">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
    <SwitchSiteModal
      :visible="switchSiteModal"
      @hideModal="hideSwitchSiteModal"
    />
  </base-nav>
</template>
<script>
import HTTPRequest from '../controllers/httpRequest';
import secureStorage from '../controllers/secureStorage';
import SwitchSiteModal from '../components/Custom/SwitchSiteModal.vue';

export default {
  components: {
    SwitchSiteModal
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      accountName: '',
      username: '',
      currentSite: {},
      siteName: null,
      // visitingSites: [],
      switchSiteModal: false
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    setCurrentSite(responseData = null) {
      let currentSite = secureStorage.getItem('currentSite');
      const currentAccountId = secureStorage.getItem('currentAccountId');
      if (currentAccountId == null) {
        secureStorage.setItem('currentAccountId', responseData.account_id);
      }
      if (currentSite == null) {
        secureStorage.setItem('currentSite', responseData.default_site);
        secureStorage.setItem('currentSiteId', responseData.default_site.id);
        currentSite = secureStorage.getItem('currentSite');
      }

      this.$store.dispatch('setCurrentSite', currentSite);
      this.currentSite = currentSite;
      this.siteName = this.currentSite?.name ?? null;
    },

    setVisitingSites(responseData) {
      const visitingSites = responseData.visiting_sites ?? [];
      if (visitingSites.length > 0) {
        secureStorage.setItem('visitingSites', visitingSites);
      }
    },

    setDefaultSite(responseData) {
      const defaultSite = responseData.default_site ?? null;
      if (defaultSite != null) {
        secureStorage.setItem('defaultSite', defaultSite);
      }
    },

    async getUserProfile() {
      try {
        const url = '/api/auth/users/me';
        const data = await HTTPRequest.getRequest(url);

        if (typeof data.error !== 'undefined' && data.error == 'Unauthorized') {
          this.$router.push({ name: 'Login' });
        }

        this.username = data.username;
        this.accountName = data.account_name;
        this.$store.dispatch('setDataPrivacyPolicy', data.dpc_policy);
        if (data.head_office.length > 0) {
          this.$store.dispatch('setHeadOffice', data.head_office[0]);
          secureStorage.setItem('headOffice', data.head_office[0].site_id);
        }
        delete data.dpc_policy;
        this.$store.dispatch('setAccount', data);

        this.setCurrentSite(data);
        this.setVisitingSites(data);
        this.setDefaultSite(data);
      } catch (e) {
        console.log('getUserProfile: ', e);
        this.$notification.error({
          message: e.toString()
        });
      }
    },

    hideSwitchSiteModal() {
      this.switchSiteModal = false;
    },

    logout() {
      secureStorage.clear();

      if (
        secureStorage.getItem('bxiClpAccessToken') == null ||
        secureStorage.getItem('bxiClpAccessToken') == undefined
      ) {
        this.$notification.success({
          message: 'Successfully logged out.'
        });

        setTimeout(() => {
          if (window.opener) {
            window.close();
          } else {
            this.$router.push({ name: 'Login' });
          }
        }, 3000);
      }
    }
  },

  created() {
    this.getUserProfile();
  }
};
</script>
